export const CommunicationState = {
  tag: 'all'
}
export const UserState = {
  user: {
    nickName: '',
    avatar: ''
  }
}
export const MessageState = {
  count: 0,
  newMessageCount: 0,
  newStarcircleCount: 0,
  newTaleCount: 0
}
export const RefreshState = {
  downRefresh: false
}
export const TabBarState = {
  tabIndex: null
}
export const DynamicTabBarState = {
  dynamicTabIndex: null
}
export const RouterState = {
  tabbarRouter: [],
  exerlandRouter: []
}
export const TabrbarModuleAuthState = {
  // home: true, // 首页
  // dynamic: false, // 发现
  // refining: true, // 开炼
  // liveList: true, // 直播
  // center: true, // 我的
  // editUserInfo: true, // 个人信息
  // communication: true
  // groupsList: true // 圈子
}
export const HomeModuleAuthState = {
  // rotation: true, // 轮播图
  // summongOrder: true, // 活动召集营
  // heatedDiscussion: true, // 热门动态
  // curriculumn: true, // 热力推荐
  // partner: true, // 对话合伙人
  // makeComplaints: true, // 星言星语
  // laboratory: true, // 实验室
  // proposal: true // 复星315
}
export const CenterModuleAuthState = {
  // editInfo: true, // 编辑个人信息
  // published: true, // 已发表内容
  // messageRecode: true, // 消息
  // summoningOrder: true, // 我的召集令
  // collection: true, // 我的收藏
  // refiningRecode: true, // 开炼记录
  // feedback: true // 建议反馈
}
export const DynamicModuleAuthState = {
  // dynamic: true, // 动态
  // message: true // 留言
  // summongOrder: true // 召集令
}
export const MakeComplainsModuleAuthState = {
  // message: true // 留言
}
export const RefiningModuleAuthState = {
  // message: true // 留言
}
export const CalendarModuleAuthState = {
  // create: true // 操作
}
// 新增
export const TopicModuleHotTopicState = {
  HotTopic: []
}
// 新增解决浏览定位
export const BrowseCoordState = {
  // 记录find页面坐标
  findScroll: 0,
  // findListCount用来记录当前加载了的条数
  findListCount: 10,
  // 记录dynamic页面坐标
  dynamicScroll: 0,
  // 记录dynamic页面当前加载的条数
  dynamicListCount: 10
}
